import ConfirmFirstMonth from './ConfirmFirstMonth'

export default ConfirmFirstMonth;